import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/core/services/account.service';
import { ToastService } from 'src/app/core/services/toast.service';
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})

export class DashboardComponent implements OnInit {
  breadCrumbItems: any;
  estampStatus: any;
  activeTab: 'esign' | 'estamp' = 'esign';

  constructor(private accountService: AccountService, private router: Router, private toastService: ToastService) { }

  ngOnInit(): void {
    this.updateBreadcrumb();
    this.loadEstampStatus();
  }

  loadEstampStatus(): void {
    this.accountService.getEstampCustomerProfile().subscribe({
      next: (res: any) => {
        this.estampStatus = res?.data?.estampService ?? null;
      },
      error: () => {
        this.estampStatus = null;
      }
    });
  }

  switchTab(tab: 'esign' | 'estamp') {
    this.activeTab = tab;
    this.updateBreadcrumb();

    if (tab == 'estamp' && this.estampStatus != 'ACTIVE') {
      const message =
        this.estampStatus === 'PENDING' || this.estampStatus === 'REQUESTED'
          ? 'Your E-Stamp service activation is pending approval.'
          : 'E-Stamp service is not active. Please activate it from your account.';

      this.toastService.showToaster('E-Stamp Service', message, 'info');
      this.router.navigate(['/customer/account'], { queryParams: { profile: 'estamp' } });
    }


  }

  private updateBreadcrumb(): void {
    this.breadCrumbItems = [
      { label: 'AVSS ' + (this.activeTab === 'esign' ? 'E-Sign' : 'E-stamp') },
      { label: 'Dashboard', active: true }
    ];
  }

}
